import React, { useEffect, useState } from 'react';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useCollection from 'Hooks/useCollection';
import relationships from 'Consts/Relationships';
import { GoalsAndObjectives as SectionKey } from 'Consts/Questionnaire';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import LoadingOverlay from 'Components/UI/LoadingOverlay/LoadingOverlay';
import CircleWithCount from 'Icons/CircleWithCount';
import {
  fetchGoals,
  saveGoal,
  removeGoal,
  goalResourcesToRecords,
} from 'Helpers/Goals';
import Section from '../Section';
import GoalSubsectionFieldlist from './GoalSubsectionFieldlist';
import './index.css';

const GoalSections = () => {
  const { householdResource, householdId } = useSimpleHousehold();
  const { collection, setCollection } = useCollection();
  const [resources, setResources] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  function getGoals() {
    if (
      householdResource
      && householdResource.relationship(relationships.goals).link('related')
    ) {
      fetchGoals(setCollection, householdResource);
    }
  }
  useEffect(() => {
    getGoals();
  }, [householdResource]);

  useEffect(() => {
    if (collection) {
      setResources(collection.resources().list());
    }
  }, [collection]);

  const addGoal = () => {
    const newResource = collection.create();
    newResource.attributes({
      type: collection
        .meta()
        .field('type')
        .export().options[0].id,
      timeHorizonValue: collection
        .meta()
        .field('timeHorizonValue')
        .export().options[0].id,
      timeHorizonType: collection
        .meta()
        .field('timeHorizonType')
        .export().options[0].id,
      priority: collection
        .meta()
        .field('priority')
        .export().options[0].id,
    });
    setIsLoading(true);

    return newResource
      .submit()
      .then(getGoals)
      .then(() => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        displayErrorMessage(err, err.errors);
      });
  };

  return (
    <Section
      expanded
      title="Goals"
      sectionKey={SectionKey}
      CountComponent={
        <CircleWithCount
          count={resources.length}
          className="expander-header-count expander-header-left"
        />
      }
      hideContinue
    >
      {isLoading && <LoadingOverlay />}
      <GoalSubsectionFieldlist
        householdId={householdId}
        loadedGoals={goalResourcesToRecords(resources)}
        saveGoal={goal => saveGoal(goal, setCollection, getGoals)}
        removeGoal={goalID => removeGoal(goalID, resources)}
        planPrompt="Create Plan"
        addGoal={() => addGoal()}
      />
    </Section>
  );
};

export default GoalSections;
